"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessRuleTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BusinessRuleTask.
 *
 * Note that the engine does not yet support these!
 */
class BusinessRuleTask extends ActivityBase_1.Activity {
    get bpmnType() {
        return Constants_1.BpmnType.businessRuleTask;
    }
}
exports.BusinessRuleTask = BusinessRuleTask;
//# sourceMappingURL=BusinessRuleTask.js.map